"use client"
import React from "react";
import Navbar from "react-bootstrap/Navbar";
import UralityAvatarImage from "@/components/shared/UralityAvatarImage";

import "@/components/maps/embed/EmbeddedNavbar.css";

const EmbeddedNavbar = ({ variant, title, logoId, onMenuClick }) => {
  const handleClick = () => onMenuClick();

  return (
    <Navbar className={`d-flex align-items-center embedded-navbar ${variant}`}>
      {logoId && <UralityAvatarImage imageId={logoId} size="sm" />}
      <Navbar.Text className="map-navbar-title">
        <h3>{title}</h3>
      </Navbar.Text>
      <div className="flex-grow" />
      {onMenuClick && (
        <span
          className="map-navbar-menu-icon"
          style={{ cursor: "pointer" }}
          onClick={handleClick}
        >
          <span className="material-icons">info</span>
        </span>
      )}
    </Navbar>
  );
};

export default EmbeddedNavbar;
